'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUBNUB_KEY = exports.PUBNUB_KEY = '@@pubNub';

var USER_DESCRIPTION_NODE_CLASSNAME = exports.USER_DESCRIPTION_NODE_CLASSNAME = 'widget-user-description';

var INITIAL_ONLINE_MODE_CHANNEL = exports.INITIAL_ONLINE_MODE_CHANNEL = 'INITIAL_ONLINE_MODE_CHANNEL';

var OFFLINE_MODE_CHANNEL = exports.OFFLINE_MODE_CHANNEL = 'OFFLINE_MODE_CHANNEL';

var PRIVATE_CHANNEL = exports.PRIVATE_CHANNEL = 'private';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/strings.js
// module id = 20
// module chunks = 0 1